var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LTileLayer',{key:"basic",attrs:{"url":_vm.url,"attribution":_vm.attribution,"visible":_vm.visible,"name":"Základní","layer-type":"base"}})}
var staticRenderFns = []

export { render, staticRenderFns }